export function isEventIdSearch(value: string | null | undefined): boolean {
    const trimmed = value?.trim();
    return !!trimmed && /^\d{5,}$/.test(trimmed);
}
